/**
 * ErrorBoundary.js
 * SC-M8-01 FIX-B: Global error boundary to prevent blank screens.
 * Catches render errors and shows a friendly fallback instead of unmounting React.
 */
import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
          minHeight: '300px', padding: '40px', textAlign: 'center'
        }} data-testid="error-boundary-fallback">
          <div style={{
            width: '60px', height: '60px', borderRadius: '50%', background: '#FEF3C7',
            display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '16px'
          }}>
            <span style={{ fontSize: '28px' }}>!</span>
          </div>
          <h3 style={{ fontSize: '18px', fontWeight: 600, color: '#1f2937', marginBottom: '8px' }}>
            Ocurrió un problema al cargar esta sección
          </h3>
          <p style={{ fontSize: '14px', color: '#6b7280', marginBottom: '20px', maxWidth: '400px' }}>
            Tu avance está guardado. Haz clic en Reintentar para continuar.
          </p>
          <button
            onClick={() => this.setState({ hasError: false, error: null })}
            style={{
              background: '#1A878D', color: '#fff', border: 'none', borderRadius: '8px',
              padding: '10px 24px', fontSize: '14px', fontWeight: 600, cursor: 'pointer'
            }}
            data-testid="error-boundary-retry"
          >
            Reintentar
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
